import gql from 'graphql-tag'

export default gql`query getEvents {
  getEvents {
    id
		header_desktop
		header_mobile
		visual_desktop
		visual_mobile
		category {
			id
			details {
				label
				language_id
			}
		}
		promote_homepage
		event_date
		details {
			name
      slug
			date
			introduction
			content
			cta_text
			cta_url
			tags
			description
      meta_title
      meta_description
      meta_tags
      meta_og_title
      meta_og_description
      meta_og_url
			language_code
			links {
				text
				url
			}
		}
		updated_at
	}
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/event/getEvents.js